<template>
  <div class="favourite-button" @click="handleClick">
    <div class="favourite-button__star-wrapper">
      <bg-icon
        name="star"
        :class="`favourite-button__star-wrapper__star-icon${
          buttonActive ? '--active' : ''
        }`"
      ></bg-icon>
    </div>
    <div class="favourite-button__title">Favourite</div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import API from "@/api";

export default {
  name: "favourite",
  components: {
    BgIcon,
  },
  data() {
    return {
      buttonActive: false,
    };
  },
  props: {
    entityType: String,
    entityData: Object,
    active: Boolean,
  },
  methods: {
    handleClick() {
      this.buttonActive = !this.buttonActive;
      switch (this.entityType) {
        case "participant":
          (async () => {
            API.test.updateFavouriteParticipant(
              this.entityData.testId,
              this.entityData.participantId
            );
          })();
      }
    },
  },
  mounted() {
    this.buttonActive = this.active;
  },
};
</script>
